module.exports = __webpack_public_path__ + "img/kf.b5772aab.png";